import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { TeamSection } from "@/components/site/TeamSection";
import { Testimonials } from "@/components/site/Testimonials";
import { Careers } from "@/components/site/Careers";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { ThemeProvider } from "@/components/site/ThemeProvider";
import { ContentProvider } from "@/components/site/content";
import { AdminDashboard } from "@/components/site/AdminDashboard";

const Landing = () => (
  <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
    <ThemeProvider />
    <ContentProvider>
      <div className="App bg-background">
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Services />
          <Manifesto />
          <TeamSection />
          <Testimonials />
          <Careers />
          <Contact />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </ContentProvider>
  </ReactLenis>
);

function App() {
  useEffect(() => {
    document.title = "Peoplelab Advisory — People · Process · Possibilities";
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
